import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetAccessManagementFeatures,
	GetAccessManagementFeaturesParams,
	GetAccessManagementFeaturesResponse,
} from 'domain/usecases';

export class RemoteGetAccessManagementFeatures implements GetAccessManagementFeatures {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAccessManagementFeaturesResponse>,
	) {}

	async get({
		signal,
	}: GetAccessManagementFeaturesParams): Promise<GetAccessManagementFeaturesResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return {funcionalidades: []};
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
